import React, { Component, Fragment } from "react";
import AllGolfersList from "../../../golfers/components/AllGolfers/AllGolfers";
import GolfersListItem from "./GolfersListItem";
import { Helmet } from "react-helmet";
import {
  H_CALC_ALL_GOLFERS_TITLE,
  H_CALC_ALL_GOLFERS_DESC,
} from "../../../../shared/variables/meta-seo";

class AllGolfers extends Component {
  renderItem = (golfer, key) => <GolfersListItem key={key} golfer={golfer} />;

  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{H_CALC_ALL_GOLFERS_TITLE}</title>
          <meta name="description" content={H_CALC_ALL_GOLFERS_DESC} />
        </Helmet>
        <AllGolfersList renderItem={this.renderItem} />
      </Fragment>
    );
  }
}

export default AllGolfers;
